<template>
  <div>
    <naj-box :title="local.bankruptcy.subRequests.representativeInfo">
      <div>
        <identity-verification-form
          :form-model="formModel.representative"
          :person-title="local.bankruptcy.subRequests.representative"
          :persons-only="true"
          :saudi-only="false"
          :is-optional="false"
          :view-mode="isViewMode "
          :manager-social-id-required="false"
          :is-lawyer="isLawyer"
          @isIdentityVerified="checkIsIdentityVerified"
          @verifiedIdentityNumber="getRepresentativeIdentityNumber"
        >
          <template
            slot="prefix"
            slot-scope="{ }"
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
                lg="3"
              >
                <naj-input
                  :type-id="formFieldType.selectbox"
                  :value.sync="formModel.representativeLegalCapacityId"
                  :label="local.bankruptcy.subRequests.requestApplicantForm.representativeLegalCapacity"
                  :items="representativeLegalCapacities"
                  item-value="id"
                  item-text="name"
                  :validates="`required`"
                  :disabled="isViewMode || isEditMode || loading"
                ></naj-input>
              </v-col>
            </v-row>
          </template>
        </identity-verification-form>
      </div>
    </naj-box>
    <attorney-form
      :form-model="formModel.requestApplicant"
      :audit-confirmations="auditConfirmations"
      :is-view-mode="isViewMode"
      :is-new-mode="isNewMode"
      :is-edit-mode="isEditMode"
      :is-not-completed="true"
      :agent="agent"
      :identity-number="identityNumber"
    ></attorney-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers(
  'BankruptcyModule'
);
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { requestOwnerTypeEnum, legalCapacitiesEnum, stakeholderTypesEnum, partyTypeEnum } from '@/modules/bankruptcy/helpers/enum';

import AttorneyForm from '../request/steps/request-applicant-data/attorney-form.vue';
import IdentityVerificationForm from '@/modules/bankruptcy/components/request/identity-verification-form.vue';

export default {
  name: 'SubRequestApplicant',
  inject: ['$validator'],
  components: {
    AttorneyForm,
    IdentityVerificationForm,
  },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    isNewMode: {
      type: Boolean,
      required: true,
    },
    isViewMode: {
      type: Boolean,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      auditConfirmations: {},
    };
  },
  computed: {
    ...mapLUTState([
      'mainRequestCategories',
      'requestOwnerTypes',
      'legalCapacities',
      'stakeholderTypes',
    ]),
    representativeLegalCapacities() {
      let legalCapacitiesData = [legalCapacitiesEnum.lawyer];
      this.$set(this.formModel, 'representativeLegalCapacityId', legalCapacitiesEnum.lawyer);
      return this.legalCapacities.filter(lc => legalCapacitiesData.includes(lc.id));
    },
    isCreditor() {
      return this.formModel.requestApplicant.stakeholderTypeId == stakeholderTypesEnum.creditor;
    },
    isPartner() {
      return this.formModel.requestApplicant.stakeholderTypeId == stakeholderTypesEnum.partner;
    },
    isDebtorEmployee() {
      return this.formModel.requestApplicant.stakeholderTypeId == stakeholderTypesEnum.employee;
    },
    isDebtor() {
      return this.formModel.requestApplicant.requestOwnerTypeId == requestOwnerTypeEnum.debtor;
    },
    isTrustee() {
      return this.formModel.requestApplicant.requestOwnerTypeId == requestOwnerTypeEnum.trustee;
    },
    agent() {
      let data = null;
      if (this.isDebtor) data = this.formModel.requestApplicant.debtor;
      if (this.isCreditor || this.formModel.requestApplicant.requestOwnerTypeId == requestOwnerTypeEnum.creditor)
        data = this.formModel.requestApplicant.creditor;
      if (this.isPartner) data = this.formModel.requestApplicant.partner;
      if (this.isDebtorEmployee) data = this.formModel.requestApplicant.debtorEmployee;
      if (this.isTrustee) data = {...this.formModel.requestApplicant.trustee, typeId: partyTypeEnum.person};
      if (!data || !this.formModel.representative?.isIdentityVerified) {
        return { isIdentityVerified: false };
      }
      return {
        ...data,
        isIdentityVerified: true
      };
    },
    identityNumber() {
      return this.formModel.representative ? this.formModel.representative.identityNumber : '';
    },
    isLawyer() {
      return this.formModel.requestApplicant.identityNumber !== null
        && this.formModel.requestApplicant.identityNumber !== undefined
        && this.formModel.requestApplicant.identityNumber == this.formModel.representative?.identityNumber;
    },
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    loadData() {
      if (this.formModel.mainRequest.isRequestOwner && !this.isViewMode) {
        this.toaster.error(this.local.bankruptcy.subRequests.addRepresentative.requestApplicantMustBeRepresentativeOrOriginalParty);
        this.$router.push({ path: `/bankruptcy` });
      }
    },
    checkIsIdentityVerified(value) {
      if (!value) {
        this.$set(this.formModel.requestApplicant, 'attorneyNumber', '');
        this.$set(this.formModel.requestApplicant, 'attorneyTypeId', '');
      }
    },
    getRepresentativeIdentityNumber(value) {
      this.$set(this.formModel, 'representative', value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
